import React from "react";
import { FaFacebookF, FaLinkedin } from "react-icons/fa";
import useTypeWriter from "../hooks/useTypeWriter";
import Shape from "./Shape";
import { motion } from "framer-motion";

const Banner = () => {
  const { str } = useTypeWriter("Muhammad Sheraz", 250);
  return (
    <section className="bg-prColor relative overflow-hidden" id="home">
      <div className="container py-[40px] sm:py-[90px] text-center">
        <h2 className="text-xl xs:text-2xl sm:text-3xl text-light font-['Merriweather']">
          Hello! I'm
        </h2>
        <h1
          className={`text-3xl xs:text-4xl sm:text-5xl text-light font-['Merriweather'] mt-6 relative  ${"cursor-indicator"} w-fit mx-auto h-[2.25rem] xs:h-[2.5rem] sm:h-[3rem]`}
        >
          {str}
        </h1>
        <motion.p
          initial={{ y: "-300px", opacity: 0, rotateZ: 90 }}
          animate={{
            y: 0,
            opacity: 1,
            transition: {
              type: "spring",
              delay: 1,
              duration: 0.5,
              stiffness: 100,
            },
            rotateZ: 0,
          }}
          className="font-['Poppins'] xs:text-lg sm:text-xl text-dark mt-6 mb-14"
        >
          Front end Developer specializing in React.js
        </motion.p>
        <div className=" mx-auto flex justify-center items-center gap-4">
          <a
            href="https://www.linkedin.com/in/sherridev/"
            className="social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin className="text-lg" />
          </a>
          <a
            href="https://web.facebook.com/SherazSaeed17/"
            className="social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookF className="text-lg" />
          </a>
        </div>
        <Shape
          position={{ bottom: "-20rem", right: "-12rem" }}
          dimension={{ first: "440px", second: "560px", third: "700px" }}
        />
      </div>
    </section>
  );
};

export default Banner;
